import { logError, logInfo } from '../logger';
import { importHauteursLibres } from './importHauteursLibres';

/**
 * Import a batch of hauteurs libres data
 * @param {Array} data - Array of structure data objects
 * @returns {Promise<Object>} - Import results
 */
export const importHauteursLibresData = async (data) => {
  try {
    if (!Array.isArray(data)) {
      throw new Error('Data must be an array of structures');
    }
    
    logInfo(`Starting import of ${data.length} structures`);
    
    // Process the import
    const results = await importHauteursLibres(data);
    
    logInfo(`Import completed: ${results.success.length} structures imported, ${results.failed.length} failed`);
    
    return {
      success: true,
      results
    };
  } catch (error) {
    logError('Failed to import hauteurs libres data:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Sample data for testing
 */
export const SAMPLE_STRUCTURES = [
  {
    reference: "01722W",
    route: "Boulevard Salaberry Nord",
    sequence: "1",
    municipalite: "Châteauguay",
    obstacle: "Chemin Saint-Bernard",
    direction_SO: "Ouest",
    hauteur_SO: "3.7",
    direction_NE: "Est",
    hauteur_NE: "3.7",
    latitude: 45.3456,
    longitude: -73.7654,
    coordinates: {
      latitude: 45.3456,
      longitude: -73.7654
    },
    details: [
      {
        point: "1",
        direction: "Nord",
        gauche: 4.5,
        centre_gauche: 4.6,
        centre: 4.7,
        centre_droit: 4.6,
        droite: 4.5,
        remarque: "RAS",
        date: "2023-05-15"
      }
    ]
  },
  {
    reference: "02345E",
    route: "Autoroute 20",
    sequence: "2",
    municipalite: "Montréal",
    obstacle: "Boulevard Saint-Jean",
    direction_SO: "Sud",
    hauteur_SO: "4.2",
    direction_NE: "Nord",
    hauteur_NE: "4.3",
    latitude: 45.4567,
    longitude: -73.6543,
    coordinates: {
      latitude: 45.4567,
      longitude: -73.6543
    },
    details: [
      {
        point: "1",
        direction: "Est",
        gauche: 4.1,
        centre_gauche: 4.2,
        centre: 4.3,
        centre_droit: 4.2,
        droite: 4.1,
        remarque: "Légère déformation",
        date: "2023-06-20"
      },
      {
        point: "2",
        direction: "Ouest",
        gauche: 4.2,
        centre_gauche: 4.3,
        centre: 4.4,
        centre_droit: 4.3,
        droite: 4.2,
        remarque: "RAS",
        date: "2023-06-20"
      }
    ]
  }
];

/**
 * Import sample data for testing
 */
export const importSampleData = async () => {
  try {
    logInfo('Importing sample hauteurs libres data');
    const results = await importHauteursLibres(SAMPLE_STRUCTURES);
    logInfo(`Sample data import completed: ${results.success.length} structures imported, ${results.failed.length} failed`);
    return results;
  } catch (error) {
    logError('Failed to import sample data:', error);
    throw error;
  }
};